<template>
  <div class="searchPage page">
    <div class="container">
      <search-template
        :search-title="pageData.content.title"
        :json-description="pageData.content.contentJson"
        list-name="Produkty ekologiczne list"
        :current-breadcrumb="pageData.content.title"
        route-name="eco"
        route-pagination-name="eco-page-number"
        only-eco
      />
    </div>
    <LazyHydrate :when-visible="{ rootMargin: '100px' }">
      <newsletter-home white />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import { mapMutations, mapState } from 'vuex';
import SearchTemplate from '~/components/SearchTemplate';

export default {
  name: 'EcoPageNumber',
  components: {
    LazyHydrate,
    SearchTemplate,
    NewsletterHome: () => import('~/components/Newsletter/NewsletterHome'),
  },
  nuxtI18n: {
    paths: {
      pl: '/produkty-ekologiczne/strona/:number',
      en: '/produkty-ekologiczne/strona/:number',
    },
  },
  async asyncData({ $config, error, $axios, route, redirect }) {
    try {
      const { data } = await $axios.get(
        `${$config.baseOfixApi}/e-commerce/v1/contents/produkty-ekologiczne`,
        {
          useCache: true,
        },
      );

      return {
        pageData: data,
      };
    } catch (e) {
      error({
        statusCode: 404,
        message: e.response.data.message ? e.response.data.message : 'Page not found',
      });
    }
  },
  head() {
    const currentPage = this.$helper.countCurrentPage(
      this.pagination.limit,
      this.pagination.offset,
    );

    const metaTags = this.pageData.seo.metaTags.map(({ content, hid, name }) => ({
      hid,
      name,
      content: content ? `Strona ${currentPage} - ${content}` : '',
    }));

    return {
      title: `${this.pageData.seo.title}`,
      meta: this.$helper.metaDescription([
        ...metaTags,
        ...[
          {
            name: 'robots',
            content: 'index, follow',
          },
        ],
      ]),
      script: [...this.$helper.schemaData(this.pageData.seo.schemaOrgData)],
      link: this.$helper.prevNextUrl(
        this.$route.query,
        this.pagination.offset,
        this.pagination.limit,
        this.pagination.countTotal,
        'eco',
        'eco-page-number',
      ),
    };
  },
  computed: {
    ...mapState({
      pagination: state => state.productsFilters.search.pagination,
    }),
  },
  destroyed() {
    this.setOnlyEco({ type: 'search', value: false });
  },
  methods: {
    ...mapMutations({
      setOnlyEco: 'productsFilters/setOnlyEco',
    }),
  },
};
</script>

<style lang="scss">
.searchPage {
  @include rwd('tablet') {
    overflow-x: hidden;
  }
}
</style>
